import React from 'react';
import classNames from 'classnames';

import css from './IconUpload.module.css';

/**
 * Add Upload
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "Upload" icon
 */
const IconUpload = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="54"
      height="56"
      viewBox="0 0 54 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9997 39.0007C28.1042 39.0007 28.9997 38.1052 28.9997 37.0007V7.7405L33.4812 12.9689C34.2 13.8076 35.4626 13.9047 36.3013 13.1858C37.1399 12.467 37.237 11.2044 36.5182 10.3657L28.5182 1.0324C28.1382 0.589109 27.5835 0.333984 26.9997 0.333984C26.4158 0.333984 25.8611 0.589109 25.4812 1.0324L17.4812 10.3657C16.7623 11.2044 16.8594 12.467 17.6981 13.1858C18.5367 13.9047 19.7993 13.8076 20.5182 12.9689L24.9997 7.7405L24.9997 37.0007C24.9997 38.1052 25.8951 39.0007 26.9997 39.0007Z"
        fill="#FCB0B3"
      />
      <path
        d="M37.6663 21.0007C35.7938 21.0007 34.8576 21.0007 34.185 21.45C33.8938 21.6446 33.6437 21.8946 33.4492 22.1859C32.9998 22.8584 32.9998 23.7947 32.9998 25.6672L32.9998 37.0007C32.9998 40.3144 30.3135 43.0007 26.9998 43.0007C23.6861 43.0007 20.9998 40.3144 20.9998 37.0007L20.9998 25.6674C20.9998 23.7947 20.9998 22.8583 20.5503 22.1857C20.3558 21.8946 20.1058 21.6446 19.8147 21.4501C19.1421 21.0007 18.2057 21.0007 16.333 21.0007C8.79054 21.0007 5.0193 21.0007 2.67615 23.3438C0.333008 25.6869 0.333008 29.4576 0.333008 37.0001V39.6667C0.333008 47.2092 0.333008 50.9804 2.67615 53.3236C5.0193 55.6667 8.79054 55.6667 16.333 55.6667H37.6663C45.2088 55.6667 48.9801 55.6667 51.3232 53.3236C53.6663 50.9804 53.6663 47.2092 53.6663 39.6667V37.0001C53.6663 29.4576 53.6663 25.6869 51.3232 23.3438C48.9801 21.0007 45.2088 21.0007 37.6663 21.0007Z"
        fill="#FCB0B3"
      />
    </svg>
  );
};

export default IconUpload;
